import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRotateLeft,
  faPlay,
  faPause,
  faBackward,
  faForward,
  faStepBackward,
  faStepForward,
  faWandMagic,
  faWandMagicSparkles,
  faSave,
  faEraser,
  faShoePrints,
  faBullseye,
  faXmark,
  faVideo,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";

const ICON_SET = {
  "arrow-left": faArrowLeft,
  "arrow-rotate-left": faArrowRotateLeft,
  play: faPlay,
  pause: faPause,
  "play-back": faBackward,
  "play-forward": faForward,
  "play-back-double": faStepBackward,
  "play-forward-double": faStepForward,
  "auto-fix": faWandMagic,
  save: faSave,
  erase: faEraser,
  foot: faShoePrints,
  target: faBullseye,
  "x-mark": faXmark,
  "video-camera": faVideo,
  "round-assessment": faChartLine,
  "baseline-hdr-auto": faWandMagicSparkles,
};

const ICON_SIZE_CLASSES = {
  sm: "h-[var(--icon-sm)] w-[var(--icon-sm)]",
  md: "h-[var(--icon-md)] w-[var(--icon-md)]",
  lg: "h-[var(--icon-lg)] w-[var(--icon-lg)]",
};

function LayoutGlyph({ className, children, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      {...props}
    >
      {children}
    </svg>
  );
}

const OUTLINE = { fill: "none", stroke: "currentColor", strokeWidth: 2 };

function LayoutBottomFill(props) {
  return (
    <LayoutGlyph {...props}>
      <rect x="2" y="3" width="20" height="11" rx="0.5" fill="currentColor" />
      <rect x="2" y="16" width="20" height="5" rx="0.5" fill="currentColor" />
    </LayoutGlyph>
  );
}

function LayoutBottomLine(props) {
  return (
    <LayoutGlyph {...props}>
      <rect x="3" y="4" width="18" height="16" rx="0.5" {...OUTLINE} />
      <line x1="3" y1="16" x2="21" y2="16" {...OUTLINE} />
    </LayoutGlyph>
  );
}

function LayoutLeftFill(props) {
  return (
    <LayoutGlyph {...props}>
      <rect x="2" y="3" width="5" height="18" rx="0.5" fill="currentColor" />
      <rect x="9" y="3" width="13" height="18" rx="0.5" fill="currentColor" />
    </LayoutGlyph>
  );
}

function LayoutLeftLine(props) {
  return (
    <LayoutGlyph {...props}>
      <rect x="3" y="4" width="18" height="16" rx="0.5" {...OUTLINE} />
      <line x1="8" y1="4" x2="8" y2="20" {...OUTLINE} />
    </LayoutGlyph>
  );
}

const CUSTOM_ICONS = {
  "layout-bottom-fill": LayoutBottomFill,
  "layout-bottom-line": LayoutBottomLine,
  "layout-left-fill": LayoutLeftFill,
  "layout-left-line": LayoutLeftLine,
};

function Icon({ name, size = "sm", className = "", testid }) {
  const sizeClass = ICON_SIZE_CLASSES[size] || ICON_SIZE_CLASSES.sm;
  const combined = className ? `${sizeClass} ${className}` : sizeClass;

  const CustomIcon = CUSTOM_ICONS[name];
  if (CustomIcon) {
    return <CustomIcon className={combined} data-testid={testid} />;
  }

  const icon = ICON_SET[name];
  if (!icon) {
    return null;
  }

  return (
    <FontAwesomeIcon
      icon={icon}
      className={combined}
      aria-hidden="true"
      data-testid={testid}
    />
  );
}

export default Icon;